export const UPDATE_NAVIGATION_STATUS = 'UPDATE_NAVIGATION_STATUS';

export const NAVIGATION_START = 'NAVIGATION_START';
export const NAVIGATION_COMPLETE = 'NAVIGATION_COMPLETE';
export const NAVIGATION_GRAPHQL = 'NAVIGATION_GRAPHQL';

export function updateNavigationStatus(status) {
    return {
        type: UPDATE_NAVIGATION_STATUS,
        payload: status,
    };
}
